import type { FacilityUser } from '../../../services/api/facilityService';

export interface UserRow {
    _id: string;
    email: string;
    name?: string | null;
    role: string;
    roleId?: string;
    status: 'active' | 'inactive' | 'pending' | 'draft';
    joinedAt?: string | null;
    sentAt?: string | null;
    reminderSentAt?: string | null;
    lastManualReminderAt?: string | null;
    expiryDate?: string | null;
    deptPermissions?: string[];
    searchesPerWeek?: number | null;
    searchesTotal?: number | null;
    removable?: boolean;
    editable?: boolean;
    selectable?: boolean;
    isInvite?: boolean;
    isCurrentUser?: boolean;
}

export type TableMode = 'onboarding' | 'management';

export function facilityUsersToRows(users: FacilityUser[]): UserRow[] {
    return users.map((user) => ({
        _id: user._id,
        email: user.email,
        name: user.name,
        role: user.role,
        roleId: user.roleId,
        status: getFacilityUserStatus(user),
        joinedAt: user.activationDate || null,
        sentAt: user.isInvite ? user.sentAt ?? null : null,
        reminderSentAt: user.isInvite ? user.reminderSentAt ?? null : null,
        lastManualReminderAt: user.isInvite
            ? user.lastManualReminderAt ?? null
            : null,
        expiryDate: user.expiryDate || null,
        deptPermissions: user.deptPermissions || [],
        searchesPerWeek: user.activity ?? null,
        searchesTotal: user.activityTotal ?? null,
        editable: true,
        selectable: true,
        removable: true,
        isInvite: user.isInvite,
    }));
}

export function isInvitationRow(user: UserRow): boolean {
    return user.isInvite === true || user.status === 'draft';
}

function getFacilityUserStatus(
    user: FacilityUser
): UserRow['status'] {
    if (user.isInvite) return 'pending';
    if (!user.expiryDate) return user.activationDate ? 'active' : 'pending';

    return new Date(user.expiryDate) > new Date() ? 'active' : 'inactive';
}
